import React, { Fragment, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Alerts, Breadcrumbs, H3, P } from "../../../AbstractElements";
import ActivityReview from "./ActivityReview";
import ProfileGreeting from "./ProfileGreeting";
import Transaction from "./Transaction";
import YearlyView from "./YearlyView";
import { useDispatch, useSelector } from "react-redux";
import { enquiryCountDashboard, enquiryCountDashboardRole, getAppVersion, getCompany, getCompanyRole, getDashboardBottomData, getDashboardBottomDataRole, getDashboardData, getDashboardDataRole, getDashboardServiceDue, getDashboardServiceDueRole, getPermissionRole, saveFcmToken, SendEmailVerification, subscribeFcmToken } from "../../../CommonUrl";
import { getClientUrlDataToken, postClientUrlWithToken, postMasterToken } from "../../../Utils/restUtils";
import ComplaintDetails from "../../Widgets/General/ComplaintDashboard";
import PaymentCollections from "../../Widgets/General/PaymentCollection";
import SubscriptionDetails from "../../Widgets/General/SubscriptionDashboard";
import TotalCollMeter from "../../Widgets/General/TotalCollMeter";
import MonthCollMeter from "../../Widgets/General/Testimonial";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import { CollectionsAgent, ConnectionMeter, Connections, MonthlyOverview, PaymentCollection, RevenueMeter, serviceMeter, serviceRequest } from "../../../Constant";
import OopserrorImageWhite from "../../Common/Oopserror/OopserrorImage";
import OpsErrorBlack from "../../Common/Oopserror/OpsErrorBlack";
import HeaderCard from "../../Common/Component/HeaderCard";
import { toast } from 'react-toastify';
import ServiceAgent from "./ServiceAgent";
import EnquiryProfile from "./EnquiryProfile";
import ServiceDueCard from "../../Widgets/General/ServiceDueCard";
import Popup from "../../Common/Popup/popup";
import { setPermissions } from "../../../Redux/Reducer";


const Default = () => {
    const [spinnerTrans, setspinnerTrans] = useState(true)
    const authState = useSelector((state) => state.auth);
    const [dataList, setDataList] = useState([]);
    const [dashboardList, setDashboardList] = useState([]);
    const [enquiry, setEnquiry] = useState();
    const [newVersion, setNewVersion] = useState('');
    const [modal, setModal] = useState(false)
    const [serviceDuesCount, setserviceDuesCount] = useState();
    const [active, setActive] = useState('');
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const years = ["All", ...Array.from({ length: currentYear - 2019 }, (_, i) => 2020 + i)];
    const navigate = useNavigate();
    const dispatch = useDispatch()

    useEffect(() => {
        dashboardData();
        companyData();
        enquiryDetails()
        handleCheckVersion()
        dashboardConnectionData();
        dashboardServiceDuesData()
        if (authState.userRole !== 1) {
            gerUserPermissions()
        }
        window.history.pushState(null, "", window.location.href);
        const handlePopState = () => {
            window.history.pushState(null, "", window.location.href);
        };
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);


    useEffect(() => {
        dashboardConnectionData();
    }, [selectedYear]);

    const dashboardData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole == 1 ? getDashboardBottomData : getDashboardBottomDataRole);
        if (data.status == true) {
            setDataList(data.data);
            setspinnerTrans(false);
        } else {
            setspinnerTrans(false);
        }
    };

    const enquiryDetails = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole == 1 ? enquiryCountDashboard : enquiryCountDashboardRole)
        if (data?.status == true) {
            setEnquiry(data.data);
            setspinnerTrans(false);
        } else {
            setspinnerTrans(false);
        }
        setspinnerTrans(false);

    }

    const dashboardConnectionData = async () => {
        const dashboardData = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getDashboardData +
            (selectedYear === "All" ? `?given_year=all` : selectedYear !== currentYear ? `?given_year=${selectedYear}` : '')
            : getDashboardDataRole +
            (selectedYear === "All" ? `?given_year=all` : selectedYear !== currentYear ? `?given_year=${selectedYear}` : '')
        );
        if (dashboardData.status == true) {
            setDashboardList(dashboardData.data);
            setspinnerTrans(false);
        } else {
            setspinnerTrans(false);
        }
    }

    const dashboardServiceDuesData = async () => {
        const dashboardData = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getDashboardServiceDue
            : getDashboardServiceDueRole
        );

        setserviceDuesCount(dashboardData)

    }
    const companyData = async () => {
        const data = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? getCompany : getCompanyRole);
        if (data.data.status == true) {
            const company_api = data.data.data;
            if (company_api.length > 0) {
                const activeCompany = company_api.filter(item => item.status == 'active');
                setActive(activeCompany[0].name);
            }
            setspinnerTrans(false);
        } else {
            setspinnerTrans(false);
        }
    };
    const gerUserPermissions = async () => {
        const data = await postClientUrlWithToken(authState.apiUrl, getPermissionRole + `?role_id=${authState.userRole}`);
        if (data.data.status === true) {
            dispatch(setPermissions(data?.data?.data))
        }
    };


    const navigateToEmail = async () => {
        const response = await postMasterToken(SendEmailVerification, { email: authState.email });
        if (response.status === 200) {
            if (response.data.status === true) {
                toast.success(response.data.message)
                navigate(`${process.env.PUBLIC_URL}/email-otp`);
            } else {
                toast.error(response.data.message)
            }
        } else if (response.status >= 400 && response.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (response.status >= 500 && response.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    }

    const handleCheckVersion = async () => {
        const currentVersion = localStorage.getItem('billerq_version')
        const data = await getClientUrlDataToken(authState.apiUrl, getAppVersion);
        setNewVersion(data?.data)
        if (currentVersion !== data?.data) {
            setModal(true)
        }
    }

    const updateNewVersion = () => {
        localStorage.setItem('billerq_version', newVersion)
        setModal(false)
        window.location.reload();

    }

    const handleModal = () => {
        setModal(!modal)
    }

    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            {/* {authState.subStatus?.email_verified === 'no' &&
                <div style={{ paddingTop: '15px' }}>
                    <Alerts attrAlert={{ color: 'danger dark' }}>
                        <P>Verify the Email! <span className="alert-link" style={{ cursor: 'pointer' }} onClick={() => navigateToEmail()}>Click here</span> to verify your Email.</P>
                    </Alerts>
                </div>
            } */}
            {/* {dataList.default_payment_method === false &&
                <div>
                    <Alerts attrAlert={{ color: 'danger dark' }}>
                        <P><span className="alert-link" style={{ cursor: 'pointer' }} onClick={() => navigate(`${process.env.PUBLIC_URL}/settings/payment`)}>Click here</span> to set the the payment method for different collection type.</P>
                    </Alerts>
                </div>
            } */}
            <Breadcrumbs mainTitle="Dashboard" title="Dashboard" parent="Dashboard" />
            <Container fluid={true} className="default-page">
                <Row>
                    {active !== '' ? (
                        <ProfileGreeting companyName={active} checks={dataList.check_condition} dataRecurring={dataList.recurring_count} />
                    ) : (
                        <Col lg={5}>
                            <Card className="profile-greeting ">
                                <CardBody>
                                    <OopserrorImageWhite />
                                </CardBody>
                            </Card>
                        </Col>
                    )}

                    {
                        (authState.userRole === 1 || authState.permissions?.includes('monthly-overview'))
                        &&
                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <YearlyView monthChart={dashboardList.collection_chart} />
                            ) : (
                                <Col xl="4" lg="3" md="6">
                                    <Card className="yearly-view" >
                                        <CardHeader className="pb-0">
                                            <H3>{MonthlyOverview}</H3>
                                        </CardHeader>
                                        <OpsErrorBlack />
                                    </Card>
                                </Col>
                            )
                        )
                    }
                    {
                        (authState.userRole === 1 || authState.permissions?.includes('service-requests')) &&

                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <ActivityReview connections={dashboardList} />
                            ) : (
                                <Col xl="3" md="6" lg="4">
                                    <Card className="activity-review" style={{ height: '265px' }}>
                                        <CardHeader className="pb-0">
                                            <H3> {serviceRequest} </H3>
                                        </CardHeader>
                                        <OpsErrorBlack />
                                    </Card>
                                </Col>
                            )
                        )}
                    {
                        (authState.userRole === 1 || authState.permissions?.includes('service-dues')) &&
                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <ServiceDueCard connections={serviceDuesCount} />
                            ) : (
                                <Col xl="6">
                                    <Row>
                                        <Col xl="12" md="12" className="box-col-12">
                                            <Card className="order-widget">
                                                <CardHeader className="pb-0">
                                                    <H3> {serviceMeter} </H3>
                                                </CardHeader>
                                                <CardBody>
                                                    <OpsErrorBlack />
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        )}
                    {
                        (authState.userRole === 1 || authState.permissions?.includes('revenue-meter')) &&
                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <TotalCollMeter collection={dashboardList.collection_meter} years={years} selectedYear={selectedYear} setSelectedYear={setSelectedYear} />
                            ) : (
                                <Col xl="6">
                                    <Row>
                                        <Col xl="12" md="12" className="box-col-12">
                                            <Card className="order-widget">
                                                <CardHeader className="pb-0">
                                                    <H3> {RevenueMeter} </H3>
                                                </CardHeader>
                                                <CardBody>
                                                    <OpsErrorBlack />
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        )}
                    {
                        (authState.userRole === 1 || authState.permissions?.includes('request-meter')) &&
                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <MonthCollMeter collection={dashboardList.collection_this_month_meter} />
                            ) : (
                                <Col xl="6">
                                    <Row>
                                        <Col xl="12" md="12" className="box-col-12">
                                            <Card className="order-widget">
                                                <CardHeader className="pb-0">
                                                    <H3> {serviceMeter} </H3>
                                                </CardHeader>
                                                <CardBody>
                                                    <OpsErrorBlack />
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>
                            )
                        )}

                    {
                        (authState.userRole === 1 || authState.permissions?.includes('payment-collections')) &&
                        (

                            Object.keys(dataList).length > 0 ? (
                                <PaymentCollections details={dataList.payment_collection} />
                            ) : (
                                <Col xl="6" className="box-col-6">
                                    <Card className="widget-joins widget-arrow">
                                        <HeaderCard title={PaymentCollection} setting={true} />
                                        <CardBody>
                                            <Row className="gy-4">
                                                <OpsErrorBlack />
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )
                        )}
                    {
                        (authState.userRole === 1 || authState.permissions?.includes('enqiry-details')) &&
                        (

                            Object.keys(dataList).length > 0 ? (
                                <EnquiryProfile details={enquiry} />
                            ) : (
                                <Col xl="6" className="box-col-6">
                                    <Card className="widget-joins widget-arrow">
                                        <HeaderCard title={'Enquiry Details'} setting={true} />
                                        <CardBody>
                                            <Row className="gy-4">
                                                <OpsErrorBlack />
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )
                        )}
                    {(authState.userRole === 1 || authState.permissions.includes('service-request-detail')) && (
                        Object.keys(dataList).length > 0 ? (
                            <ComplaintDetails data={dataList.complaints} />
                        ) : (
                            <Col xl="6" className="box-col-6">
                                <Card className="widget-joins complainHeight">
                                    <HeaderCard title={'Complaint Details'} setting={true} />
                                    <CardBody>
                                        <Row className="gy-4">
                                            <OpsErrorBlack />
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    )}
                    {/* {(authState.userRole === 1 || authState.permissions.includes('show-subscription')) && (
                        Object.keys(dataList).length > 0 ? (
                            <SubscriptionDetails details={dataList.subscriptions} />
                        ) : (
                            <Col xl="6" className="box-col-6">
                                <Card className="widget-joins">
                                    <HeaderCard title={'Subscription Details'} setting={true} />
                                    <CardBody>
                                        <Row className="gy-4">
                                            <OpsErrorBlack />
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    )} */}
                    {

                        (

                            Object.keys(dashboardList).length > 0 ? (
                                <>
                                    {
                                        (authState.userRole === 1 || authState.permissions?.includes('collection-by-staff')) &&
                                        <Transaction collectionAgent={dashboardList.agent_collection} />

                                    }
                                    {
                                        (authState.userRole === 1 || authState.permissions?.includes('service-by-staff')) &&

                                        <ServiceAgent collection={dashboardList.agent_complaints} />
                                    }
                                </>
                            ) : (
                                <Col xl="6">
                                    <Card className="transaction-history">
                                        <CardHeader className="pb-0">
                                            <H3>{CollectionsAgent}</H3>
                                        </CardHeader>
                                        <CardBody>
                                            <div className="dashboardTable">
                                                <OpsErrorBlack />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            )
                        )}
                </Row>
                <Modal isOpen={modal} toggler={handleModal} size="md" centered className='modal-pop-up-width'>
                    <ModalHeader>
                        New Update
                    </ModalHeader>
                    <ModalBody>
                        <div className="">
                            <h4 className="modal-title fw-semibold">
                                New Update Available 🚀
                            </h4>
                        </div>

                        <div className=" mt-3">
                            <p>
                                A new version of this application is available.
                            </p>
                        </div>

                        <div className="d-flex justify-content-end">
                            <button
                                className="btn btn-primary px-4"
                                onClick={updateNewVersion}
                            >
                                Update Now
                            </button>
                        </div>
                    </ModalBody>
                </Modal>
                {/* <Popup isOpen={modal} title='Update' toggler={handleModal} size="md">

                </Popup> */}
            </Container>
            <Outlet />
        </Fragment>
    );
};

export default Default;